import * as React from 'react'
import { Export } from 'bvdash-core/icons'

import HeaderButton from './HeaderButton'

export default ({ onExport }) => (
  <HeaderButton label="Export" icon={Export} onClick={onExport} />
)
